module.exports = __webpack_public_path__ + "img/new_logo.47a0922c.jpeg";